<script lang="ts">
  import SalesForceChat from "@shared/services/salesforce_chat";
  import { restrictRepAccess } from "@retailer/services/preview_forbidden_flash";

  export let message: string;
  export let brandprimary: boolean = false;
  export let bold: boolean = true;
  export let extraClassNames = "";
  export let onClick = () => {};

  function startChat() {
    onClick();

    if (!restrictRepAccess()) {
      SalesForceChat.open();
    }
  }
</script>

<a
  href={"#"}
  target="_self"
  on:click|preventDefault={startChat}
  class:light-body--bold={bold}
  class:color-brandPrimary={brandprimary}
  class={`underline fizz-underline cursor-pointer ${extraClassNames}`}>{message}</a
>
